export const toLocalUSString = (value) => {
    if (!value) {
        return '';
    }

    return Number(value).toLocaleString('en-US');
};
